import { resolveJobId } from '~/utils/jobUtils';
import { useUserContext } from '~/react_context/UserContext';

interface UseInternalJobIdReturn {
	isEnabled: boolean;
	shouldShowInternalId: (internalJobId?: string | null) => boolean;
	resolveJobId: (jobId: number, internalJobId?: string | null) => string;
}

export function useInternalJobId(): UseInternalJobIdReturn {
	const { enableInternalJobId } = useUserContext();
	const isEnabled = enableInternalJobId;

	const shouldShowInternalId = (internalJobId?: string | null): boolean => {
		return isEnabled && !!internalJobId;
	};

	return {
		isEnabled,
		resolveJobId: (jobId, internalJobId) => resolveJobId({ enableInternalJobId: isEnabled, internalJobId, jobId }),
		shouldShowInternalId,
	};
}
